import { getAppConfig } from '@srichaitra/config';
import { getHttpClient } from './httpClient';
import { ApiError } from './ApiError';

/**
 * Calls the backend's single dispatch endpoint with { action, data } and
 * unwraps the envelope.
 *
 * Every capability the server has is reached through this one function — the
 * backend registers named actions rather than exposing routes (see
 * NodeJS/src/actions). Adding a screen that talks to a new action needs no new
 * transport code, only a new named wrapper in this library.
 */
export async function execute(action, data) {
  const { executePath } = getAppConfig().api;
  const response = await getHttpClient().post(executePath, { action, data });

  if (!response.data?.success) {
    const error = response.data?.error;
    throw new ApiError(
      error?.code ?? 'UNKNOWN_ERROR',
      error?.message ?? 'Request failed',
      response.status,
      response.data?.requestId ?? null
    );
  }

  return response.data.data;
}
